import React from 'react';

import * as S from './styles';

const InputGroup: React.FC = ({ children, ...rest }) => {
  return <S.InputGroup {...rest}>{children}</S.InputGroup>;
};

export default InputGroup;
